module.exports = __webpack_public_path__ + "static/week_week5_spot5-64d36ee856d9c8a4566c0bb936037e53.jpg";